export default __webpack_public_path__ + "static/media/Directory.f46656c3.svg";